module.exports = __webpack_public_path__ + "static/media/infoJumbo2.830860b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/sllaser/images/infoJumbo2.jpg
// module id = 545
// module chunks = 0